// extracted by mini-css-extract-plugin
export default {"iconLink":"FileIcon_iconLink__efRdt","iconTitle":"FileIcon_iconTitle__jPeWG","icon":"FileIcon_icon__RL7sk","iconImage":"FileIcon_iconImage__tTMXT"};